import {Directive, HostListener} from '@angular/core';

@Directive({
    selector: '[nxNoScroll]',
    standalone: false
})
export class NxNoScrollDirective {

  @HostListener('wheel', ['$event'])
  onWheel(event: Event) {
    event.preventDefault();
  }

}
